// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageModal_wrapper__Dtj8I","close":"ImageModal_close__7vG6w","image":"ImageModal_image__aGxcl","buttons":"ImageModal_buttons__-xySC","button":"ImageModal_button__2tury"};